import { gql } from "@/__generated__/gql";

export const DESTROY_PROFILE_ANSWER_MUTATION = gql(`
  mutation DestroyProfileAnswer($input: DestroyProfileAnswerMutationInput!) {
    destroyProfileAnswerMutation(input: $input) {
      clientMutationId
      errors {
        message
        title
      }
      success
    }
  }
`);
